module.exports = __webpack_public_path__ + "img/prodpage_5.13a971f9.png";